import { PerspectiveCamera, Frustum, Matrix4 } from 'three';

class Camera extends PerspectiveCamera {
  constructor() {
    super(45, window.innerWidth / window.innerHeight, 0.01, 1000);
    this.position.set(0, 0, 15);
    this.updateMatrix();
    this.updateMatrixWorld(); // make sure the Camera matrix is updated

    // Add frustum to check Elements positions

    this.frustum = new Frustum();
    const cameraViewProjectionMatrix = new Matrix4();
    this.matrixWorldInverse.getInverse(this.matrixWorld);
    cameraViewProjectionMatrix.multiplyMatrices(this.projectionMatrix, this.matrixWorldInverse);
    this.frustum.setFromMatrix(cameraViewProjectionMatrix);
  }
}

export default new Camera();
